'use strict';

var MULTIPLIERS = {
  'Hours': 60 * 60 * 1000,
  'Minutes': 60 * 1000,
  'Seconds': 1000,
  'Milliseconds': 1
};

module.exports = MULTIPLIERS;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/range/var/MULTIPLIERS.js
// module id = 318
// module chunks = 0